import { render, staticRenderFns } from "./HowToServers.vue?vue&type=template&id=4073fe8a&scoped=true"
import script from "./HowToServers.vue?vue&type=script&lang=js"
export * from "./HowToServers.vue?vue&type=script&lang=js"
import style0 from "./HowToServers.vue?vue&type=style&index=0&id=4073fe8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4073fe8a",
  null
  
)

export default component.exports